import psHttp from '@patsnap/common-ps-http';
import { coreBasicApiUrlPrefix } from '../../config/constants';

export function getAclCheckApi(keys) {
    return psHttp({
        url: `${coreBasicApiUrlPrefix}/analytics/acl/check`,
        method: 'POST',
        data: { key: keys },
        transformCode: true
    }).then(({ data }) => {
        return data.data || {};
    });
}
